<script>
  import { format } from 'svelte-i18n';
  import { Button, Dropdown, DropdownMenu, DropdownToggle, Input } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let props = {};

  let scores = { ...props.leadscores };
  let isOpen = false;
  let disabled = true;
  let previousScores = { ...scores };

  const labels = {
    'beaconview-viewed': $format('label.EMAIL_VIEWED'),
    'linkclick-clicked': $format('label.LINK_CLICKED'),
    'websitevisited-visited': $format('label.WEBSITE_VISIT'),
    'adclick-clicked': $format('label.AD_CLICKED'),
    'attachmentview-viewerlaunched': $format('label.ATTACHMENT_VIEWED'),
    'attachmentdownload-downloaded': $format('label.ATTACHMENT_DOWNLOADED'),
    'myvideoactivity-myplayerlaunched': $format('label.VIDEO_VIEWED')
  };

  const updateLeadScores = () => {
    Object.keys(scores).forEach((key) => {
      scores[key] = Number(scores[key]);
    });

    if (props.onUpdate) {
      props.onUpdate(scores);
    }

    previousScores = { ...scores };
    isOpen = false;
  };

  const resetLeadScores = () => {
    scores = { ...props.originalLeadScores };
    previousScores = { ...scores };

    if (props.onReset) {
      props.onReset(scores);
    }

    isOpen = false;
  };

  $: if (isOpen) {
    Object.keys(scores).forEach((key) => {
      scores[key] = Number(scores[key]);
    });

    disabled = JSON.stringify(scores) === JSON.stringify(previousScores);
  }
</script>

<div class="scoring">
  {$format('label.INTENT_SCORE')}
  <span role="button" tabindex="0" on:click|preventDefault|stopPropagation>
    <Dropdown {isOpen} toggle={() => (isOpen = !isOpen)}>
      <DropdownToggle tag="span" class="inline">
        <Icon name="settings" class="d-block" />
      </DropdownToggle>
      <DropdownMenu>
        <div class="columns">
          <div class="column-headings">
            <span>{$format('label.EVENT')}</span>
            <div>{$format('label.WEIGHT')}</div>
          </div>

          {#each Object.entries(scores) as [key, value]}
            <div class="field">
              <span>{labels[key]}</span>
              <Input type="number" min="0" step="1" bind:value={scores[key]} />
            </div>
          {/each}

          <div class="actions">
            <Button color="primary" bind:disabled size="sm" on:click={updateLeadScores}>
              {$format('label.APPLY')}
            </Button>
            <Button color="secondary" size="sm" on:click={resetLeadScores}>{$format('label.RESET')}</Button>
          </div>
        </div>
      </DropdownMenu>
    </Dropdown>
  </span>
</div>

<style lang="scss">
  .scoring {
    align-items: center;
    display: flex;
    gap: 5px;
  }


  .actions {
    align-items: center;
    display: flex;
    gap: 8px;
    margin-left: 90px;
    padding-bottom: var(--padding-base);
  }

  .columns {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: var(--padding-small) var(--padding-large);
    width: 250px;
  }

  .field,
  .column-headings {
    align-items: center;
    display: flex;
    gap: 8px;

    span {
      font-size: var(--font-size-medium);
      font-weight: var(--font-weight-base);
      width: 150px;
    }
  }

  .column-headings {
    border-bottom: 1px solid var(--border-color);
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-medium);
    padding: var(--padding-base) 0;

    span {
      font-weight: var(--font-weight-medium);
      width: 80px;
    }
  }
</style>
